export class AddigitalMgid {

    constructor() {
        this.init();
    }

    init() {
        window.MgSensorData = window.MgSensorData || [];
        return window.MgSensorData;
    }

    push(query) {
        window.MgSensorData.push(query);
    }

    otherPageViewed()
    {
        this.push(Object.assign(this.getQueryTemplate()));
    }

    productPageViewed(product)
    {
        this.push(Object.assign(this.getQueryTemplate(), {
            eid: product.id
        }));
    }

    orderThankyouPageView(basket) {
        let ids = [];
        basket.forEach(product => {
            ids.push(product.id);
        });
        this.push(Object.assign(this.getQueryTemplate(), {
            goods: ids
        }));
    }

    getQueryTemplate() {
        return {
            partner     : '584717',
            cid         : 280113,
            lng         : 'us',
            nosafari    : true,
            eid         : 0,
            project     : 'a.mgid.com',
            goods       : [0]
        }
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/addigital-mgid.js